import { render, staticRenderFns } from "./default-roster-grades.vue?vue&type=template&id=327043c5&scoped=true&"
import script from "./default-roster-grades.ts?vue&type=script&lang=ts&"
export * from "./default-roster-grades.ts?vue&type=script&lang=ts&"
import style0 from "./default-roster-grades.scss?vue&type=style&index=0&id=327043c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327043c5",
  null
  
)

export default component.exports